import { render, staticRenderFns } from "./PageNotFound-Mobile.vue?vue&type=template&id=666835ee&scoped=true&"
import script from "./PageNotFound-Mobile.vue?vue&type=script&lang=js&"
export * from "./PageNotFound-Mobile.vue?vue&type=script&lang=js&"
import style0 from "./PageNotFound-Mobile.vue?vue&type=style&index=0&id=666835ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666835ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
